<template>
  <div
    id="app"
    class="config-app"
    :class="{ 'config-app--full-screen': isFullScreen() }"
  >
    <div class="logo">
      <router-link :to="{ name: 'home' }">
        <img src="/images/UltimateEars.svg" alt="Ultimate Ears" />
      </router-link>
    </div>
    <Wrapper v-if="loaded && !httpError" />
    <div v-if="httpError" class="failed-to-load">
      <p>An error occurred when loading. Please try later.</p>
    </div>
  </div>
</template>

<script>
import store from "./store";
import Wrapper from "./Wrapper";
export default {
  name: "app",
  created() {
    console.log(this.$route);
    if (this.$route.params.locale) {
      console.log("setting locale");
      store.commit("setLocale", this.$route.params.locale);
    }
    store.dispatch("getProducts").then(() => {
      store
        .dispatch("getProductOptions", {
          productId: store.state.productBeingConfigured.Id
        })
        .then(() => {
          store.dispatch("getProductPricing");
        });
    });
    // need to make sure the store has loaded before we load a config in the url
    store.watch(
      state => state.loaded,
      (newVal, oldVal) => {
        let queryKeys;
        console.log("loaded the store finally");
        if (this.$route.query) {
          queryKeys = Object.keys(this.$route.query);
        }
        if (queryKeys.length) {
          // add items in query string to the store
          // if there is a query string in the url
          console.log("query keys");
          queryKeys.forEach(queryKey => {
            let query;
            if (queryKey === "CustomText") {
              query = this.$route.query[queryKey];
            } else {
              query = parseInt(this.$route.query[queryKey]);
            }
            if (queryKey === "CustomText") {
              if (query) {
                store.commit("updateCustomText", decodeURIComponent(query));
              } else {
                store.commit("updateCustomText", "");
              }
            } else {
              // get the option by id
              const option = this.findOptionById(queryKey, query);
              console.log(option, "option to load");
              store.commit("selectOption", {
                CategoryName: queryKey,
                Id: query
              });
            }
          });
        }
      }
    );
  },
  updated() {},
  watch: {
    $route(to, from) {
      utag_data.page_name = to.name;
      if (to.name === "SpeakerChoices" || to.name === "SpeakerText") {
        utag_data.luckyCombo = to.params.id.toString();
      } else {
        utag_data.luckyCombo = null;
      }

      $("body").trigger("screen_load");
    }
  },
  computed: {
    productOptions() {
      return store.state.productOptions;
    },
    loaded() {
      return store.state.loaded;
    },
    httpError() {
      return store.state.httpError;
    }
  },
  components: { Wrapper },
  methods: {
    findOptionById(category, id) {
      const options = store.state.productOptions[category];
      if (options) {
        return options.Options.filter(option => option.Id === id);
      }
    },
    isFullScreen() {
      switch (this.$route.name) {
        case "home":
        case "Intro":
        case "custom":
          return true;
        default:
          return false;
      }
    }
  }
};
</script>

<style lang="scss">
@import "./scss/reset";
@import "./scss/variables";
@import "./scss/spacing";
/*
--------------------------------------------------
	Fonts
--------------------------------------------------
*/

// Regular
@font-face {
  font-family: "News Gothic";
  font-style: normal;
  font-weight: 100;
  src: url("fonts/7feeddb9-43b6-461a-97b6-b56aff5e8106.eot?#iefix");
  src: url("fonts/7feeddb9-43b6-461a-97b6-b56aff5e8106.eot?#iefix")
      format("eot"),
    url("fonts/288db151-e7a2-4878-becc-a2fcf43b7413.woff2") format("woff2"),
    url("fonts/16d0ae15-a315-4df1-a24c-7addb09b5eef.woff") format("woff"),
    url("fonts/f87bf9c6-814b-4e50-bc84-247e8b0a841d.ttf") format("truetype"),
    url("fonts/3f2579a8-dff8-4c55-8a9d-ba8ec6b7c5b0.svg#3f2579a8-dff8-4c55-8a9d-ba8ec6b7c5b0")
      format("svg");
}

// Bold
@font-face {
  font-family: "News Gothic";
  font-style: normal;
  font-weight: 700;
  src: url("fonts/2f1e98db-85dd-4534-94c9-c229191511d4.eot?#iefix");
  src: url("fonts/2f1e98db-85dd-4534-94c9-c229191511d4.eot?#iefix")
      format("eot"),
    url("fonts/56b92164-b225-4957-8c67-71be001ca592.woff2") format("woff2"),
    url("fonts/c9c438fb-cc69-4afa-8784-732af7594cc5.woff") format("woff"),
    url("fonts/4dd05b9f-d17c-4622-9bb5-4f9dc0902f05.ttf") format("truetype"),
    url("fonts/db64de75-8a77-4996-b276-5453aba0b2c1.svg#db64de75-8a77-4996-b276-5453aba0b2c1")
      format("svg");
}

// Aliases for fonts above without the font-style and font-weight restraints
@font-face {
  font-family: "News Gothic W01";
  src: url("fonts/7feeddb9-43b6-461a-97b6-b56aff5e8106.eot?#iefix");
  src: url("fonts/7feeddb9-43b6-461a-97b6-b56aff5e8106.eot?#iefix")
      format("eot"),
    url("fonts/288db151-e7a2-4878-becc-a2fcf43b7413.woff2") format("woff2"),
    url("fonts/16d0ae15-a315-4df1-a24c-7addb09b5eef.woff") format("woff"),
    url("fonts/f87bf9c6-814b-4e50-bc84-247e8b0a841d.ttf") format("truetype"),
    url("fonts/3f2579a8-dff8-4c55-8a9d-ba8ec6b7c5b0.svg#3f2579a8-dff8-4c55-8a9d-ba8ec6b7c5b0")
      format("svg");
}
@font-face {
  font-family: "News Gothic W01 Bold706740";
  src: url("fonts/2f1e98db-85dd-4534-94c9-c229191511d4.eot?#iefix");
  src: url("fonts/2f1e98db-85dd-4534-94c9-c229191511d4.eot?#iefix")
      format("eot"),
    url("fonts/56b92164-b225-4957-8c67-71be001ca592.woff2") format("woff2"),
    url("fonts/c9c438fb-cc69-4afa-8784-732af7594cc5.woff") format("woff"),
    url("fonts/4dd05b9f-d17c-4622-9bb5-4f9dc0902f05.ttf") format("truetype"),
    url("fonts/db64de75-8a77-4996-b276-5453aba0b2c1.svg#db64de75-8a77-4996-b276-5453aba0b2c1")
      format("svg");
}

.mfp-helper {
  height: 100%;
  position: fixed;
  width: 100%;

  &--transparent {
    // transparent modal (like the buy modal)
    .mfp-container {
      padding: 0;
    }
    .mfp-content {
      min-height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      top: 0;
      position: absolute;
      @media (min-width: 768px) {
        align-items: stretch;
        .modal--transparent {
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
      }
    }
  }

  body {
    position: fixed;
    width: 100%;
  }

  body {
    overflow: hidden;
    transform: translateZ(0);
    height: 100%;
  }
  .mfp-wrap {
    -webkit-overflow-scrolling: touch;
    transform: translateZ(0);
  }
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

// for full page effect
html.html--feeling-lucky {
  background-color: $greyLight;
}
html.full-page {
  height: 100%;
  body {
    height: 100%;
  }
  .config-app {
    height: 100%;
    &--full-screen {
      @media (min-width: 992px) {
        overflow: hidden;
      }
    }
  }
  .config-wrapper {
    height: 100%;
  }
  .config-top {
    height: calc(100% - 100px);
    overflow: hidden;
    @media (min-width: 992px) {
      height: calc(100% - 132px);
    }
  }
  .config-canvas-wrapper {
    overflow: hidden;
    @media (max-width: 991px) {
      width: 0;
      height: calc(100% - 73px);
      @media (min-width: 768px) {
        height: calc(100% - 103px);
      }
    }
    @media (min-width: 992px) {
      height: 100%;
      @media (min-height: 930px) {
        overflow: visible;
      }
    }
  }
  .config-canvas-equalizer {
    height: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    @media (min-height: 1150px) and (min-width: 992px) {
      align-items: center;
    }
  }
  .feeling-lucky-wrapper {
    height: 100%;
  }
  .speaker-wrapper {
    height: 100%;
  }
}

body {
  color: $black;
  background: $white;
  font-family: $font;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: 700;
}

a,
button,
input,
select {
  &:focus {
    outline: none;
  }
}

button,
input {
  margin: 0;
}

.canvas-container {
  width: 100% !important;
  height: auto !important;
  box-sizing: border-box;
  padding-top: 0;
  padding-bottom: 260.6%;
  top: 0;
  &--front {
    right: 0;
  }
  &--back {
    left: 0;
  }
  .canvas {
    width: 100% !important;
    height: 100% !important;
  }
}

.config-app {
  background-color: $greyLight;
  z-index: 0;
  position: relative;
}

.btn {
  border: 4px solid currentColor;
  background-color: transparent;
  text-transform: uppercase;
  color: currentColor;
  font-weight: bold;
  text-decoration: none;
  padding: 1rem 1.4rem;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  line-height: 1;
  position: relative;
  font-family: $font;
  font-size: 0.85em;
  display: flex;
  transition: all 0.3s;
  text-align: center;
  &:hover {
    cursor: pointer;
  }
  @media (min-width: 992px) {
    &:hover {
      border-color: $greyDark;
      color: $greyDark;
    }
  }

  &[disabled] {
    opacity: 0.15;
    cursor: not-allowed;
  }
  img {
    max-width: 25px;
    margin-right: 0.75em;
  }

  &--white {
    background-color: white;
    color: #000;
    border-color: white;
    @media (min-width: 992px) {
      &:hover {
        color: $greyDark;
      }
    }
  }

  &--full-width {
    width: 100%;
  }

  &--link {
    text-decoration: none;
  }

  &--inverse {
    background-color: black;
    border-color: black;
    color: white;
    @media (min-width: 992px) {
      &:hover {
        background-color: $greyDark;
        color: white;
      }
    }

    &::after {
      background-color: black !important;
    }
  }

  &--all-white {
    background-color: white;
    border-color: white;
  }

  &--has-image {
    // reduce top and bottom padding to compensate for the image
    padding-top: 0.75em;
    padding-bottom: 0.75em;
  }

  &--right {
    border: none;
    background: transparent url("/images/ArrowButton_Outline.svg") center right
      no-repeat;
    background-size: auto 100%;
    border-left: 4px solid #000;
    padding-right: 2rem;
    text-align: left;
    @media (min-width: 992px) {
      &:hover {
        background-color: transparent;
        color: currentColor;
        border-color: currentColor;
      }
      justify-content: flex-start;
      &:after {
        content: "";
        padding: 1rem 1.4rem;
        box-sizing: border-box;
        background: transparent url("/images/ArrowButton_Outline_hover.svg")
          center right no-repeat;
        position: absolute;
        background-size: auto 100%;
        background-color: transparent !important;
        right: 0;
        top: 0;
        left: 0;
        bottom: 0;
        opacity: 0;
        width: 100%;
        transition: opacity 0.25s;
      }
      &:hover {
        border-color: $greyDark;
        color: $greyDark;
        &:after {
          opacity: 1;
        }
      }
    }
    &.btn--inverse {
      background-image: url("/images/ArrowButton_Filled.svg");
      position: relative;
      transition: color 0.25s, border-color 0.25s;

      @media (min-width: 992px) {
        &:after {
          content: attr(data-text);
          padding: 1rem 1.4rem;
          box-sizing: border-box;
          background: transparent url("/images/ArrowButton_Filled_hover.svg")
            center right no-repeat;
          position: absolute;
          background-size: auto 100%;
          background-color: transparent !important;
          right: 0;
          top: 0;
          left: 0;
          bottom: 0;
          z-index: 1;
          opacity: 0;
          transition: opacity 0.25s;
        }
        &:hover {
          color: white;
          border-color: $greyDark;
          &:after {
            opacity: 1;
          }
        }
        &[disabled] {
          border-color: #000;
          &:after {
            transition: none;
            opacity: 0;
          }
        }
      }
      &.btn--centered {
        @media (min-width: 992px) {
          &:after {
            padding: 1rem 1.4rem 1rem calc(1.4rem - 10px);
          }
        }
      }
    }
    &.btn--centered {
      text-align: center;
    }
    &.btn--all-white {
      background-image: url("/images/ArrowButton_Filled_white.svg");
      border-left-color: white;
    }
  }

  &--left {
    border: none;
    background: transparent url("/images/ArrowButton_Outline_left.svg") center
      left no-repeat;
    background-size: auto 100%;
    border-right: 4px solid #000;
    padding-left: 2rem;
    text-align: left;

    @media (min-width: 992px) {
      &:hover {
        background-color: transparent;
        color: currentColor;
        border-color: currentColor;
      }
      justify-content: flex-start;
      &:after {
        content: "";
        padding: 1rem 1.4rem;
        box-sizing: border-box;
        background: transparent
          url("/images/ArrowButton_Outline_left_hover.svg") center left
          no-repeat;
        position: absolute;
        background-size: auto 100%;
        background-color: transparent !important;
        right: 0;
        top: 0;
        left: 0;
        bottom: 0;
        opacity: 0;
        width: 100%;
        transition: opacity 0.25s;
      }
      &:hover {
        border-color: $greyDark;
        color: $greyDark;
        &:after {
          opacity: 1;
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.logo {
  max-width: 135px;
  margin-left: auto;
  margin-right: auto;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  @media (min-width: 992px) {
    max-width: 159px;
  }
  a,
  img {
    display: block;
  }
}
.failed-to-load {
  padding-top: 100px;
  text-align: center;
  color: red;
  height: 100vh;
  box-sizing: border-box;
}
</style>
